import { z } from '@harvestiq/zod';
import { safeDbUserSchema } from './db-user';

export const unblockUsersRequestBodySchema = z.object({
  ids: z.array(z.string().uuid()).min(1),
});
export type UnblockUsersRequestBody = z.infer<
  typeof unblockUsersRequestBodySchema
>;

export const unblockUsersResponseSchema = z
  .object({
    users: safeDbUserSchema.array(),
  })
  .or(
    z.object({
      errors: z.string().array(),
    })
  );
export type UnblockUsersResponse = z.infer<typeof unblockUsersResponseSchema>;
